(() => {
    let dependendentFields = document.querySelectorAll('[data-dep]');

    const setupDependency = (field, label) => {
        field.style.display = 'none';
        let values = label.dataset.depVal.split(',');
        if (!this.idMap) {
            this.idMap = {};
        }

        for (let i=0; i<values.length; i++) {
            let dep = label.dataset.dep;
            let index = (+values[i] - 1);
            this.idMap['form-input-' + dep + '-' + index] = true;
        }

        let options = document.querySelectorAll('[name="' + label.dataset.dep + '"]');

        if (options.length) {
            for (let i=0; i<options.length; i++) {
                options[i].addEventListener('click', (e) => {
                    if (this.idMap[e.target.id]) {
                        field.style.display = 'block';
                    }
                    else {
                        field.style.display = 'none';
                    }
                });
            }
        }
        else {
            // checkboxes
            options = document.querySelectorAll('[name="' + label.dataset.dep + '[]"]');
            for (let i=0; i<options.length; i++) {
                options[i].addEventListener('click', (e) => {
                    if (this.idMap[e.target.id] && e.target.checked) {
                        field.style.display = 'block';
                    }
                    else {
                        field.style.display = 'none';
                    }
                });
            }
        }

    };

    for (let i=0; i<dependendentFields.length; i++) {
        setupDependency(dependendentFields[i].closest('.form__row'), dependendentFields[i]);
    }

})();